const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

/**
 * Resolve a product image URL.
 * Accepts an absolute URL (returned as-is) or a relative path starting with /
 * (prefixed with REACT_APP_BACKEND_URL so it loads from the right backend).
 */
export function productImage(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/")) return `${BACKEND}${url}`;
  return url;
}

export { BACKEND };
